import { PlanningQuestion } from 'src/types/planning';

// Sentinel value used to represent the "Other (specify below)" option in both
// single-select (radio) and multi-select (checkbox) question types.
export const FREE_TEXT_OPTION = '__free_text__';

// A single unified answer shape works for both question types:
//   - single-select: `selected` holds at most one value
//   - multi-select:  `selected` can hold many values
// Both include a `freeText` field populated when FREE_TEXT_OPTION is selected.
export interface Answer {
    selected: Set<string>;
    freeText: string;
}

export const initAnswers = (
    questions: PlanningQuestion[]
): Record<number, Answer> =>
    questions.reduce(
        (acc, _, idx) => ({
            ...acc,
            [idx]: { selected: new Set<string>(), freeText: '' }
        }),
        {}
    );
